<ps-ui-modal class="quota-modal">
  <ps-ui-modal-body>
    <div
      class="alert alert-danger"
      role="alert"
      *ngIf="hasMoreQuotasThanCompletes"
    >
      There are more quotas than completes available. Some nested quotas have 0
      quantity available. This may cause unexpected behavior - please revise
      nested quotas if this warning is unexpected.
    </div>

    <div class="text-center mx-width">
      <h2 class="header-title">Nesting</h2>
      <p class="description-text">
        To auto-nest a qualification condition, first add a quantity to the
        desired condition in the appropriate modal.
      </p>
    </div>

    <div class="nesting-quotas-button">
      <td *ngFor="let qualificationForNest of allQualifications">
        <button
          *ngIf="qualificationForNest.isVisible"
          class="btn"
          [ngClass]="{
            'nesting-quotas-button-selected': qualificationForNest.isSelected
          }"
          (click)="toggleSelectQualification(qualificationForNest)"
        >
          <p>
            {{ qualificationForNest.qualification_name | capitalize }}
          </p>
        </button>
      </td>
    </div>
    <div class="scroll_table">
      <table class="nested-quota-table">
        <thead class="nested-quota-head">
          <th>Nested Quota Details</th>
          <th colspan="8">Allocation</th>
          <th colspan="4">Flexibility</th>
          <th>Fielded</th>
        </thead>
        <thead class="nested-quota-head">
          <th>
            <span *ngFor="let nestesQuota of selectedNestedQuotas">{{
              nestesQuota.qualification_name
            }}</span>
          </th>
          <th colspan="3">#</th>
          <th colspan="3">%</th>
          <th colspan="3">MIN</th>
          <th colspan="3">MAX</th>
          <th colspan="3">&nbsp;</th>
        </thead>
        <tbody class="nested-quota-body">
          <tr *ngFor="let nestedQuota of nestedQuotas">
            <td>
              <span *ngFor="let combinedKey of nestedQuota.combinedKey">
                {{ combinedKey }}
              </span>
            </td>
            <td colspan="3">
              <div *ngIf="!nestedQuota.isAllocationEdit" class="editable-div">
                {{ nestedQuota.required_count || nestedQuota.number || 0 }}
                <div
                  class="pencil-outer pencil-outer-qbp"
                  (click)="
                    nestedQuota.isAllocationEdit = true;
                    nestedQuota.initialQuotaAllocation =
                      nestedQuota.required_count || nestedQuota.number || 0;
                    nestedQuota.required_count =
                      nestedQuota.required_count || nestedQuota.number || 0;
                    disableApplyNesting = false
                  "
                >
                  <div class="fa fa-pencil"></div>
                </div>
              </div>
              <div
                class="edit-button-group"
                *ngIf="nestedQuota.isAllocationEdit"
              >
                <input
                  class="inputText hover-font-color input-qbp-cpi edit-qouta-input"
                  type="number"
                  [ngModel]="nestedQuota.required_count"
                  (ngModelChange)="nestedQuota.required_count = $event"
                  *ngIf="nestedQuota.isAllocationEdit"
                />
                <div
                  class="fa fa-check glyphicon glyphicon-ok"
                  (click)="
                    nestedQuota.isAllocationEdit = false;
                    updateQuotaAllocation(nestedQuota)
                  "
                ></div>
                <div
                  class="fa fa-remove glyphicon glyphicon-remove"
                  (click)="
                    nestedQuota.isAllocationEdit = false;
                    setInitialAllocation(nestedQuota)
                  "
                ></div>
              </div>
            </td>
            <td colspan="3">
              <div *ngIf="!nestedQuota.isPercentageEdit" class="editable-div">
                {{ nestedQuota.percentage | number : '1.0-2' }}
                <div
                  class="pencil-outer pencil-outer-qbp"
                  (click)="
                    nestedQuota.isPercentageEdit = true;
                    nestedQuota.initialQuotaPercentage = nestedQuota.percentage;
                    disableApplyNesting = false
                  "
                >
                  <div class="fa fa-pencil"></div>
                </div>
              </div>

              <div
                class="edit-button-group"
                *ngIf="nestedQuota.isPercentageEdit"
              >
                <input
                  class="inputText hover-font-color input-qbp-cpi edit-qouta-input"
                  type="number"
                  [(ngModel)]="nestedQuota.percentage"
                  max="100"
                  min="0"
                  *ngIf="nestedQuota.isPercentageEdit"
                />
                <div
                  class="fa fa-check glyphicon glyphicon-ok"
                  (click)="
                    nestedQuota.isPercentageEdit = false;
                    updateQuotaPercentage(nestedQuota)
                  "
                ></div>
                <div
                  class="fa fa-remove glyphicon glyphicon-remove"
                  (click)="
                    nestedQuota.isPercentageEdit = false;
                    nestedQuota.percentage = nestedQuota.initialQuotaPercentage
                  "
                ></div>
              </div>
            </td>
            <td colspan="3">{{ nestedQuota.minimum }}</td>
            <td colspan="3">{{ nestedQuota.maximum }}</td>
            <td colspan="3">{{ nestedQuota.fielded }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="nesting-buttons">
      <button psUiButton color="primary" (click)="clearNesting()">
        Clear Nesting
      </button>
      <button
        psUiButton
        color="primary"
        (click)="applyNesting()"
        [disabled]="disableApplyNesting"
      >
        Apply Nesting
      </button>
    </div>
  </ps-ui-modal-body>
</ps-ui-modal>
